import React from 'react'

import { getPlanBySlug } from '@smarty-nx/contentful'
import { Typography } from '@smarty-nx/ds'
import cn from 'classnames'
import Countdown from 'react-countdown'

import { content } from './countdown-banner.content'
import classes from './countdown-banner.module.scss'
import { CountdownBannerProps } from './countdown-banner.types'
import { timeFormat } from '../../utils/timeFormat'

const getNewDataAllowanceOrName = (
  planName,
  dataAllowanceGB,
  dataAllowanceWithPromosGB
) => {
  if (dataAllowanceGB > 0 && dataAllowanceGB === dataAllowanceWithPromosGB) {
    return dataAllowanceGB + 'GB'
  }

  if (dataAllowanceGB > 0 && dataAllowanceWithPromosGB !== dataAllowanceGB) {
    return dataAllowanceWithPromosGB + 'GB'
  }

  return planName
}

const CountdownBanner = ({
  planName,
  planSlug,
  voucherExpiryDate,
  discountedPrice,
  originalPrice,
  dataAllowanceGB,
  dataAllowanceWithPromosGB,
}: CountdownBannerProps) => {
  const planMeta = getPlanBySlug(planSlug)
  if (!planMeta) {
    return null
  }

  const { slug, planColor } = planMeta

  const dataAllowanceOrName = getNewDataAllowanceOrName(
    planName,
    dataAllowanceGB,
    dataAllowanceWithPromosGB
  )
  const oldDataAllowance =
    dataAllowanceGB > 0 && dataAllowanceWithPromosGB !== dataAllowanceGB
      ? dataAllowanceGB + 'GB'
      : null

  const price =
    originalPrice === discountedPrice ? originalPrice : discountedPrice
  const oldPrice =
    originalPrice !== discountedPrice && !oldDataAllowance
      ? originalPrice
      : null

  return (
    <a
      className={cn(
        classes.root,
        classes[`backgroundColour${planColor?.theme.replace('/', '')}`]
      )}
      href={`/order/${slug}`}
    >
      <div className={classes.wrapper}>
        <div className={classes.dataAndPriceSection}>
          <div>
            <Typography
              component="span"
              variant="Kollektif/ExtraLarge"
              className={classes.dataOrName}
            >
              {dataAllowanceOrName}
            </Typography>
          </div>
          <div className={classes.dataAndPriceSecondLine}>
            {oldDataAllowance && (
              <Typography
                component="span"
                variant="Kollektif/Large"
                className={classes.originalData}
              >
                {oldDataAllowance}
              </Typography>
            )}
            {oldPrice && (
              <Typography
                component="span"
                variant="Kollektif/Large"
                className={classes.originalPrice}
              >
                {' '}
                £{oldPrice}
              </Typography>
            )}
            <Typography
              component="span"
              variant="Kollektif/Large"
              className={classes.price}
            >
              £{price}
            </Typography>
          </div>
        </div>

        <div className={classes.timeSection}>
          {content.durations.map((d) => (
            <div className={classes.time} key={d.time}>
              <Countdown
                date={voucherExpiryDate}
                renderer={(props) => (
                  <div className={classes.timeColumn}>
                    <div className={classes.timeNumbers}>
                      <Typography
                        component="p"
                        variant="Kollektif/Large"
                        className={classes.timeNumber}
                      >
                        {timeFormat(props[d.time])[0]}
                      </Typography>
                      <Typography
                        component="p"
                        variant="Kollektif/Large"
                        className={classes.timeNumber}
                      >
                        {timeFormat(props[d.time])[1]}
                      </Typography>
                    </div>
                    <Typography
                      component="p"
                      variant="Kollektif/MediumEmphasis"
                      className={classes.timeLegend}
                    >
                      {d.text_to_display}
                    </Typography>
                  </div>
                )}
              />
            </div>
          ))}
        </div>
      </div>
    </a>
  )
}

export default CountdownBanner
